import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Button, Typography, TextField, LinearProgress, Dialog, Select, MenuItem, InputLabel } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import {AccountStyle} from './AccountStyle';
import {validator} from 'components/utils/validator';
import { mapAccountChit } from 'components/mapper/objectMapping';
import Constants from 'components/utils/constants';
import mapStateToProps from 'reducers/actions/stateToProps';
import { AccountHandler } from 'chits-data/dist';
import mapDispatchToProps from 'reducers/actions/dispatchProps';
let console = Constants.consoleWrapper(false);
class NewChitTermForm extends Component {
    constructor(props) {
      super(props)
      this._handler = new AccountHandler();
    }
  
    state = {
		currencies: [],
        subscribers: [],
        selectedSub: '',
		accountTypes: ['DEF'],
		sqlErrorMessage: '',
		actionInProgress      : {
			openLinearLoading   : false,
			disableActionButton : false
		},
		account : {},
        accountChit: {},
        accountArchiveConfirmation: false,
        page : 0
    };

    componentDidMount() {

        let ac = this._handler.getActiveAccount();
        // asynchronously load account information to props
        this._handler.getAccountCached(ac).then((account) => {
            if (account) {
                this.props.setCurrentAccount(account);
    
                console.debug("NewChitTermForm->ComponentDidMount()->this.props.wallet.current", account)
                this._handler.fetchAccount(account._id).then((account)=>{
                    // Fetch latest copy of subscribers from server
                    this._handler.getAccountSubscribersCached(account._id, true).then((subs)=>{
                        this.setState({
                            subscribers: subs.filter((sub)=>{
                                return !sub.isBid;
                            }),
                            account,
                            accountChit: mapAccountChit(account.chit_info)
                        })
                    })
                })
            }
        });
        
    }

    handleAllChitAccountFieldValidation = () => {
		let _account = this.state.accountChit;
        let allPassed = true;
        Object.keys(_account).forEach((name)=>{
            let _field = _account[name];
            let rules = Object.keys(_field.rules);
    
            //_field.value = _field.value;
    
            if (rules) {
                for (let rule of rules) {
                    if (_field.rules[rule] && rule in validator) {
                        let validation = validator[rule](_field.value, _field.rules[rule]);
    
                        if (!validation.passed) {
                            _field.hasErrors.error = true;
                            _field.hasErrors.message = validation.message;
                            allPassed = false;
    
                            break;
                        }
                        else {
                            _field.hasErrors.error = false;
                            _field.hasErrors.message = validation.message;
                        }
                    }
                }
            }
        })

		this.setState({
			accountChit : _account,
		});

        if (allPassed) {
            this.handleCreateChitTerm();
        }
    }

    handleChitAccountFieldValidation  = (e) => {
		let _account = this.state.accountChit;
		let _field = _account[e.target.name];
		let rules = Object.keys(_field.rules);

		_field.value = e.target.value;

		if (rules) {
			for (let rule of rules) {
				if (_field.rules[rule] && rule in validator) {
					let validation = validator[rule](_field.value, _field.rules[rule]);

					if (!validation.passed) {
						_field.hasErrors.error = true;
						_field.hasErrors.message = validation.message;

						break;
					}
					else {
						_field.hasErrors.error = false;
						_field.hasErrors.message = validation.message;
					}
				}
			}
		}

		this.setState({
			accountChit : _account
		});

    }
    
    handlePrevPage = async () => {
        this.setState({
            page: 0
        })
    }

	handleCreateChitTerm = async () => {
		let _account = this.state.account;
        // console.log('handleCreateChitTerm->_account', _account);
        let _accountChit = this.state.accountChit;
		let _actionInProgress = this.state.actionInProgress;
		_actionInProgress.disableActionButton = true;
		_actionInProgress.openLinearLoading = true;
		this.setState({
			actionInProgress : _actionInProgress
		});
		
        let term = _account.chit_info.nextTerm;
        let payload = {
            term,
            date: this.props.nextTermDate,
            bidId: this.state.selectedSub,
            fundvalue: _accountChit.chit_amount.value / 1,
            emi: _accountChit.chit_term_amount.value / 1,
            commission: _accountChit.chit_commission.value / 1,
            penalty: Number(_accountChit.chit_term_fee.value)
        }
        let isSuccess = true;
        this._handler.postNewChitTerm(_account._id, payload).then((response)=>{
            //
        }).finally(()=>{
            _actionInProgress.disableActionButton = false;
            _actionInProgress.openLinearLoading = false;
            this.setState({
                actionInProgress : _actionInProgress
            });
            if (isSuccess && this.props.onSubmit) this.props.onSubmit();
        })
	};

    handleUpdateAccount = async () => {
        let _id = this.props.wallet.current._id;
        if (!_id) {
            this.props.enqueueSnackbar('Account Id missing to update', {
                variant : 'warning'
            });
            return;
        }
        let chit_info = this._handler.prepareObjectForSaving(this.state.accountChit);
        let payloadAccount = {
            chit_info
        }
        // this._handler.nav.setActionInProgress();
        this._handler.getInstance()
            .patch(`${Constants.URLs.ACCOUNTS}/` + _id, payloadAccount)
            .then((response) => {
                if (response.status === 400) {
                    this.props.enqueueSnackbar('Error: An internal error occured while saving account..', {
                        variant : 'error'
                    });
                    this.setState({
                        sqlErrorMessage  : response.data.message,
                    });
                    this.props.onSubmit();
                }
                else {
                    this.props.enqueueSnackbar('Account updated successfully', {
                        variant : 'success'
                    });
                    this.setState({ 
                        openOverlay: true, 
                    });
                    this.props.onSubmit();
                }
            })
            .catch((error) => {
                console.error(error);
                this.props.enqueueSnackbar('Error: Could not update the account.', {
                    variant : 'error'
                });
            })
            // .finally(()=>this._handler.nav.unsetActionInProgress())
    };

    getTextField(fieldName) {
        const {classes} = this.props;
        let field = this.state.accountChit[fieldName];
        if (!field) return;
        let {alias, value, hasErrors, type} = field;
        return (
            <Grid item md={12} lg={12} xs={12}>
                <TextField
                    name={fieldName}
                    label={alias}
                    className={classes.textField}
                    value={value ? value : "text"}
                    type={type ? type : 'text'}
                    required={true}
                    onChange={this.handleChitAccountFieldValidation}
                    variant="standard" // opt: standard, outlined or filled
                    helperText={hasErrors.message}
                    inputProps={{
                        readOnly: this.props.readOnly,
                    }}
                    InputProps={{
                        className: (this.props.readOnly) ? 'Mui-disabled' : undefined,
                    }}
                />
            </Grid>
        )
    }

    handleSubscriberFieldChange = (e) => {
        this.setState({
            selectedSub: e.target.value
        })
    }
    getBidderSelectField() {
        const {classes} = this.props;
        let _sub = this.state.selectedSub;
        return (
            <Grid item md={12} lg={12} xs={12}>
                <InputLabel>Who is Lifting Chit (Bidder)?</InputLabel>
                <Select
                    name="chit-bidder"
                    value={_sub ? _sub : ""}
                    className={classes.textField}
                    style={{paddingTop: '20x' }}
                    onChange={this.handleSubscriberFieldChange}
                    // disabled={this.props.readOnly}
                    >
                        {this.state.subscribers.map((sub, index) => {
                            return (
                                <MenuItem
                                    key={`type-${sub.sid}`}
                                    value={sub.index}>
                                    {`${sub.name}`}
                                </MenuItem>
                            );
                        })}
                </Select>
            </Grid>
        )
    }

    renderFields() {
        return (
            <Grid container>
                {this.getBidderSelectField()}     
                {/* {this.getTextField('chit_amount')}
                {this.getTextField('chit_tenure')}
                {this.getTextField('chit_subscribers')}
                {this.getTextField('chit_term_amount')}
                {this.getTextField('chit_start_on')}
                {this.getTextField('chit_term_fee')}
                {this.getTextField('chit_draw_date')}
                {this.getTextField('chit_due')} */}
            </Grid>
        )
    }
    
    renderActions() {
        const {classes} = this.props;
        let validTerm = this.props.wallet.current.chit_info.nextTerm && this.props.wallet.current.chit_info.nextTerm > 0;
        return (
            <Grid item md={12} lg={12} xs={12}>
                <div className={classes.newReleaseModalActions} data-cy="mdlCreateNewReleaseActions">
                    {/* {!this.props.hideActions && !this.props.modeUpdate && <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        data-cy="mdlCreateNewAccountActionCancel"
                        onClick={() => this.handlePrevPage()}>
                        Back
                    </Button>} */}
                    {!this.props.hideActions && this.props.readOnly && <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        data-cy="mdlCreateNewAccountActionCancel"
                        onClick={() => this.props.onEnableEdit()}>
                        EDIT
                    </Button>}
                    {!this.props.hideActions && !this.props.readOnly && <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        data-cy="mdlCreateNewAccountActionCancel"
                        onClick={() => this.props.onCancel()}>
                        Cancel
                    </Button>}
                    {!this.props.hideActions && !this.props.readOnly && !this.props.modeUpdate && this.state.selectedSub && validTerm && <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        data-cy="mdlCreateNewAccountActionSubmit"
                        disabled={this.state.actionInProgress.disableActionButton}
                        onClick={this.handleCreateChitTerm}>
                        Submit
                    </Button>}
                    {!this.props.hideActions && !this.props.readOnly && this.props.modeUpdate && <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        data-cy="mdlCreateNewAccountActionSubmit"
                        disabled={this.state.actionInProgress.disableActionButton}
                        onClick={this.handleUpdateAccount}>
                        Update
                    </Button>}
                </div>
            </Grid>
        )
    }

    renderForm() {
        const {classes} = this.props;
        return (
            <Grid container className={classes.newReleaseModal} data-cy="mdlCreateNewChitTermGrid">
                <Grid item md={12} lg={12} xs={12}>
                    <Typography variant="h6" align="center">
                        {this.props.modeUpdate ? '' : `New Chitfund Term: Term ${this.props.wallet.current.chit_info.nextTerm}`}
                    </Typography>
                </Grid>

                {this.renderFields()}

                <Grid item md={12} lg={12} xs={12}>
                    <Typography variant="caption" align="center" className={classes.sqlErrorMessage}>
                        {this.state.sqlErrorMessage}
                    </Typography>
                </Grid>

                {this.renderActions()}
                
                {this.state.actionInProgress.openLinearLoading && (
                    <LinearProgress color="secondary" variant="query" />
                )}
            </Grid>
        )
    }

    renderAsGrid() {
        return (
            <div>
                {this.props.display && this.renderForm()}
            </div>
        )
    }

    renderAsDialog() {
        return (
            <Dialog
                open={this.props.display}
                // center
                // showCloseIcon={false}
                // closeOnOverlayClick={false}
                // closeOnEsc={false}
                onClose={() => {}}
                // styles={{ modal: { padding: 0, height } }}
                style={{margin: '10px'}}
                >
                {this.renderForm()}
            </Dialog>
        )
    }

    render() {
        if (this.props.asDialog) {
            return this.renderAsDialog();
        } 
        return this.renderAsGrid();
    }
}

NewChitTermForm.propTypes = {
  classes: PropTypes.object.isRequired,
  display: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  modeUpdate:  PropTypes.bool.isRequired,
  onBusy: PropTypes.func,
  asDialog: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  onEnableEdit: PropTypes.func,
  hideActions: PropTypes.bool,
  hideArchive: PropTypes.bool,
  nextTermDate: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(withStyles(AccountStyle)(NewChitTermForm)));
  